import { ReactComponent as curveArrow } from "../../src/assets/svg/curveArrow.svg";

import { ReactComponent as PlayIcon } from "../../src/assets/svg/playIcon.svg";
import { ReactComponent as DiscoverIcon } from "../../src/assets/svg/discoverIcon.svg";

import { ReactComponent as CloseIcon } from "../../src/assets/svg/closeIcon.svg";
import { ReactComponent as ZoomInIcon } from "../../src/assets/svg/zoomInIcon.svg";
import { ReactComponent as BackIcon } from "../../src/assets/svg/backIcon.svg";

import { ReactComponent as SelectIcon } from "../../src/assets/svg/selectIcon.svg";


export const icons = {
  general: {
    curveArrow,
    PlayIcon,
    DiscoverIcon,
    CloseIcon,
    ZoomInIcon,
    BackIcon,
    SelectIcon
  }
}